/** Created by azhou on 2019/2/15.*/
<template>
  <div :class="[type === 'textarea' ? 'd-start-center':'d-center']">
    <span v-if="leftText" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="d-center" v-if="leftText"><div class="form-left-text">{{leftText}}</div>：</div>
    <div class=" input-self-border" style="text-align:left;">
    <el-time-picker
      is-range
      v-model="value2"
      size="small"
      style="width:229px;"
      format='HH:mm'     
      value-format="HH:mm"  
      @change="()=>{ this.$emit('input', value2.join(','))}"
      placeholder="选择日期">
    </el-time-picker>       
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LeftTextBorder',
    props: {
      value: {
        type: String,
        default: ''        
      },
      type: {
        type: String,
        default: 'text'
      },
      leftText: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      inputId: {                       //input id，用作百度地图自动完成的id指向
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      appendText: {}
    },

    data(){
      return {
        value2:''
      }
    },

    watch:{
      value(nval){
        console.log(nval);
        if(nval){
          this.value2=nval.split(nval.indexOf('～')<0?',':'～')
        }
      }
    },

    mounted(){
      if(this.value){
        
        this.value2=this.value.split(this.value.indexOf('～')<0?',':'～')
      }      
    },

    methods:{
      // 保存textarea中的换行空格符号
      formatValue(value) {
        return value.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
      }
    }
  }
</script>
<style lang="scss" scoped>
  .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self-border {
    width: 100%;
    box-sizing: border-box;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 100%;
      border-radius: 3px;
      font-size: 14px;
      &:focus{
        outline: none;
        border: 1px solid #26a2ff;
      }
    }
    input{height: 34px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
</style>
